/**
 * Tour steps — Attacks domain
 * Cubre: attack-library (clave), mitre-coverage (KILLER), atomic-runs, attack-packs
 */

import {
  Target,
  GridFour,
  ClockCounterClockwise,
  Package
} from '@phosphor-icons/react';

// ============ ATTACK LIBRARY (clave en quick) ============
const attackLibraryProspect = {
  id: 'attack-library',
  title: 'Pon a prueba tus defensas',
  description: 'Lanza ataques controlados contra tu propia red para ver si las defensas funcionan de verdad. Más de 1.700 técnicas reales listas para ejecutar.',
  icon: Target,
  position: 'right',
  highlight: '[data-testid="nav-attack-library"]',
  fallbackSelector: '[href="/attack-library"]',
  mode: 'prospect',
  length: 'both',
  domain: 'attacks',
  videoFallback: null
};

const attackLibraryOnboarding = {
  id: 'attack-library',
  title: 'Attack Library — 1782 Atomic Tests',
  description: 'Catálogo completo de Atomic Red Team importado. Lanza pruebas controladas por técnica MITRE, con ejecución real en agentes (executor en agent v1.10.0) y telemetría completa.',
  icon: Target,
  position: 'right',
  highlight: '[data-testid="nav-attack-library"]',
  fallbackSelector: '[href="/attack-library"]',
  mode: 'onboarding',
  length: 'both',
  domain: 'attacks',
  videoFallback: null
};

// ============ MITRE COVERAGE (KILLER, clave en quick) ============
const mitreCoverageProspect = {
  id: 'mitre-coverage',
  title: 'Mapa de qué ataques cubres y cuáles no',
  description: 'Una rejilla visual que muestra qué técnicas de ataque conocidas detectarías hoy y cuáles te pasarían inadvertidas. Lo que ven todos los CISOs en sus reuniones de board.',
  icon: GridFour,
  position: 'right',
  highlight: '[data-testid="nav-mitre-coverage"]',
  fallbackSelector: '[href="/mitre-coverage"]',
  mode: 'prospect',
  length: 'both',
  domain: 'attacks',
  videoFallback: null
};

const mitreCoverageOnboarding = {
  id: 'mitre-coverage',
  title: 'MITRE ATT&CK Navigator heatmap',
  description: 'Cross-reference entre Atomic tests ejecutables y reglas de detección activas (Sigma + correlación). Fallback técnica→táctica con ~150 entradas. Identifica gaps de detección por táctica.',
  icon: GridFour,
  position: 'right',
  highlight: '[data-testid="nav-mitre-coverage"]',
  fallbackSelector: '[href="/mitre-coverage"]',
  mode: 'onboarding',
  length: 'both',
  domain: 'attacks',
  videoFallback: null
};

// ============ ATOMIC RUNS (solo full) ============
const atomicRunsProspect = {
  id: 'atomic-runs',
  title: 'Histórico de ataques lanzados',
  description: 'Revisa qué pruebas has hecho, cuándo, contra qué equipos y si tu sistema las detectó. Evidencia objetiva para auditorías.',
  icon: ClockCounterClockwise,
  position: 'right',
  highlight: '[data-testid="nav-attack-library-runs"]',
  fallbackSelector: '[href="/attack-library/runs"]',
  mode: 'prospect',
  length: 'full',
  domain: 'attacks',
  videoFallback: null
};

const atomicRunsOnboarding = {
  id: 'atomic-runs',
  title: 'Attack Library — Run History',
  description: 'Histórico de ejecuciones atomic con stdout/stderr del agente, técnica MITRE, target host, timestamp y alerta correlacionada (si la regla disparó). Útil para purple team retros.',
  icon: ClockCounterClockwise,
  position: 'right',
  highlight: '[data-testid="nav-attack-library-runs"]',
  fallbackSelector: '[href="/attack-library/runs"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'attacks',
  videoFallback: null
};

// ============ ATTACK PACKS (solo full) ============
const attackPacksProspect = {
  id: 'attack-packs',
  title: 'Packs temáticos listos para usar',
  description: 'Paquetes preconfigurados por escenario (ransomware, robo de credenciales) que despliegan ataque + detección + plan de respuesta en un clic.',
  icon: Package,
  position: 'right',
  highlight: '[data-testid="nav-packs"]',
  fallbackSelector: '[href="/packs"]',
  mode: 'prospect',
  length: 'full',
  domain: 'attacks',
  videoFallback: null
};

const attackPacksOnboarding = {
  id: 'attack-packs',
  title: 'Attack Packs',
  description: 'Bundles activables por tenant: Ransomware Q1 2026 incluye 15 Atomic tests + 20 reglas Sigma + playbook markdown. Activación atómica desde UI con un solo endpoint.',
  icon: Package,
  position: 'right',
  highlight: '[data-testid="nav-packs"]',
  fallbackSelector: '[href="/packs"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'attacks',
  videoFallback: null
};

export const domainSteps = {
  prospect: {
    quick: [attackLibraryProspect, mitreCoverageProspect],
    full: [attackLibraryProspect, mitreCoverageProspect, atomicRunsProspect, attackPacksProspect]
  },
  onboarding: {
    quick: [attackLibraryOnboarding, mitreCoverageOnboarding],
    full: [attackLibraryOnboarding, mitreCoverageOnboarding, atomicRunsOnboarding, attackPacksOnboarding]
  }
};
